import { parseString } from 'utils/parsingHelpers'

export type EODNote = {
  created_date: string
  updated_date?: string
  note: string
  user: string
  id: string
}

export const parseEODNote = (value: unknown): EODNote | undefined => {
  if (!value || typeof value !== 'object') return undefined

  const data = value as Record<string, unknown>
  return {
    created_date: parseString(data.created_date) ?? '',
    updated_date: parseString(data.updated_date),
    note: parseString(data.note) ?? '',
    user: parseString(data.user) ?? '',
    id: parseString(data.id) ?? '',
  }
}
